import { useEffect, useState } from "react";

function diff(target) {
  const now = new Date();
  const t = new Date(target).getTime();
  const d = t - now.getTime();
  if (d <= 0) return null;
  const days = Math.floor(d / (1000 * 60 * 60 * 24));
  const hours = Math.floor((d / (1000 * 60 * 60)) % 24);
  const minutes = Math.floor((d / (1000 * 60)) % 60);
  const seconds = Math.floor((d / 1000) % 60);
  return { days, hours, minutes, seconds };
}

export default function Countdown({ target }) {
  const [t, setT] = useState(() => diff(target));

  useEffect(() => {
    const id = setInterval(() => setT(diff(target)), 1000);
    return () => clearInterval(id);
  }, [target]);

  if (!t) {
    return (
      <div
        data-testid="countdown-live"
        className="font-accent text-xs text-white/90"
      >
        Vacanza in corso ✦ Buon viaggio
      </div>
    );
  }

  const box = (v, l) => (
    <div className="flex flex-col items-center">
      <div className="font-display text-3xl md:text-4xl text-white leading-none">
        {String(v).padStart(2, "0")}
      </div>
      <div className="font-accent text-[10px] text-white/90 mt-1">{l}</div>
    </div>
  );

  return (
    <div
      data-testid="countdown"
      className="inline-flex items-center gap-6 px-6 py-4 rounded-2xl bg-white/10 backdrop-blur-md border border-white/20"
    >
      {box(t.days, "Giorni")}
      <span className="text-white/40">:</span>
      {box(t.hours, "Ore")}
      <span className="text-white/40">:</span>
      {box(t.minutes, "Min")}
      <span className="text-white/40 hidden sm:inline">:</span>
      <span className="hidden sm:block">{box(t.seconds, "Sec")}</span>
    </div>
  );
}
